import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>
          Explore our gallery to see how we keep your home and pets safe with our gentle yet effective bug elimination services. From flea-free pets to pest-free homes, we use pet-safe treatments to ensure a happy and healthy environment for your furry companions.

With every treatment, we focus on bringing peace of mind to you and comfort to your pets. See the transformation, and trust us to make your home a pest-free sanctuary.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
